/**
 * Internal dependencies
 */
 const { registerCheckoutBlock } = wc.blocksCheckout;

import { WooFoodOrderTypeBlockFront } from './block';
import metadata from './block.json';

registerCheckoutBlock( {
	metadata,
	component: WooFoodOrderTypeBlockFront,
} );